var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9997 0.333496C12.2797 0.333496 0.333008 12.2802 0.333008 27.0002C0.333008 41.7202 12.2797 53.6668 26.9997 53.6668C41.7197 53.6668 53.6663 41.7202 53.6663 27.0002C53.6663 12.2802 41.7197 0.333496 26.9997 0.333496ZM21.6663 36.3335V17.6668C21.6663 17.4192 21.7354 17.1765 21.8655 16.9658C21.9957 16.7552 22.1818 16.585 22.4034 16.4743C22.6247 16.3635 22.8727 16.3166 23.1194 16.3389C23.3661 16.3611 23.6015 16.4516 23.7997 16.6002L36.253 25.9335C36.973 26.4668 36.973 27.5335 36.253 28.0668L23.7997 37.4002C23.6015 37.5487 23.3661 37.6391 23.1194 37.6615C22.8727 37.6836 22.6247 37.6367 22.4034 37.526C22.1818 37.4154 21.9957 37.2452 21.8655 37.0346C21.7354 36.8239 21.6663 36.5812 21.6663 36.3335Z",
    fill: "#14142A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlack);
export default __webpack_public_path__ + "static/media/play-black.390f9750cccf1e47ff2e2d1fc8ffab90.svg";
export { ForwardRef as ReactComponent };